<template>
  <div class="image-grid">
    <div class="image-container" v-bind:style="styles">
      <img 
        v-for="(image, index) in images" 
        v-bind:src="image" 
        v-bind:key="image"
        ref="images" 
        v-if="index < 4" 
        class="image" 
        :class="imageClass"
        @click="imageSelected(index)" 
      />
      <div :class="`excess-${imageOrientation}`" v-if="remainingImages() > 0" @click="showGallery(3)">
        <p>+{{remainingImages()}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Gallery from '@/components/common/Gallery';

export default {
  name: 'ImageGrid',
  components: {
    Gallery,
  },
  props: {
    boxWidth: {
      type: String,
      default: 'auto',
    },
    boxHeight: {
      type: String,
      default: '200px',
    },
    boxBorder: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    styles: {
      width: this.boxWidth,
      height: this.boxHeight,
      overflow: 'hidden',
    },
    imageClass: 'single-h',
    imageOrientation: 'h',
    selectedIndex: 0,
    galleryVisible: false,
  }),
  mounted() {
    this.imageClass = this.determineClass(this.$refs.images[0]);
    this.imageOrientation = this.determineOrientation(
      this.$refs.images[0].naturalWidth,
      this.$refs.images[0].naturalHeight,
    );
  },
  methods: {
    totalImages() {
      return this.images.length;
    },

    remainingImages() {
      return this.totalImages() - 4;
    },

    determineOrientation(width, height) {
      if (width > height) {
        return 'h';
      }
      return 'v';
    },

    determineClass(image) {
      const gridClasses = {
        1: 'single',
        2: 'double',
        3: 'triple',
        4: 'quadruple',
      };
      const gridClass = gridClasses[this.totalImages()] || 'quadruple';
      return `${gridClass}-${this.determineOrientation(image.naturalWidth, image.naturalHeight)}`;
    },

    imageSelected(index) {
      this.$emit('imageSelected', [this.images, index]);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.image-container {
  width: 370px;
  height: 370px;
  display: inline-block;
  position: relative;

  img {
    object-fit: cover;
    border: 1px solid #fff;
    cursor: pointer;
  }
}

.single-h,
.single-v {
  width: 100%;
  height: 100%;
}

// Double Horizontal
.double-h {
  height: 50%;
  width: 100%;
}

.double-v {
  width: 50% !important;
  height: 100%;
}

// Triple Horizontal
.triple-h:first-child {
  height: 61.8%;
  width: 100%;
}

.triple-h:nth-child(2),
.triple-h:nth-child(3) {
  width: 50% !important;
  height: 38.2%;
  float: left;
}

// Triple Vertical
.triple-v:first-child {
  width: 61.8% !important;
  height: 100%;
  float: left;
}

.triple-v:nth-child(2),
.triple-v:nth-child(3) {
  height: 50%;
  width: 38.2% !important;
  float: right;
}

// Quadruple Horizontal
.quadruple-h:first-child {
  height: 61.8%;
  width: 100%;
}

.quadruple-h:nth-child(2),
.quadruple-h:nth-child(3),
.quadruple-h:nth-child(4) {
  width: 33.3333% !important;
  height: 38.2%;
  float: left;
}

// Quintuple Vertical
.quadruple-v:first-child {
  width: 61.8% !important;
  height: 100%;
  float: left;
}

.quadruple-v:nth-child(2),
.quadruple-v:nth-child(3),
.quadruple-v:nth-child(4) {
  height: 33.3333%;
  width: 38.2% !important;
  float: right;
}

.excess-h {
  position: absolute;
  height: 38.2%;
  width: 33.3333%;
  background: #000;
  opacity: 0.4;
  text-align: center;
  color: #fff;
  right: 0;
  font-size: 32px;
  cursor: pointer;

  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.excess-v {
  position: absolute;
  height: 33.3333%;
  width: 38.2%;
  background: #000;
  opacity: 0.4;
  text-align: center;
  color: #fff;
  right: 0;
  bottom: 0;
  font-size: 32px;
  cursor: pointer;

  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>




// WEBPACK FOOTER //
// ImageGrid.vue?a91e8b02